export const SELF_SELECTION_MODE = 'self selection';
export const AUTO_SELECTION_MODE = 'auto selection';
export const CUSTOM_GROUP_MODE = 'custom group';
export const MAX_CAMPAIGN_DURATION_DAYS = 180;

export enum CreatorSelectionModes {
  JOB_LISTING = 'JOB_LISTING',
  CUSTOM_GROUP = 'CUSTOM_GROUP',
  SELF_SELECTION = 'SELF_SELECTION',
}

export enum NewCreatorSelectionModes {
  JOB_LISTING = 'JOB_LISTING',
  CUSTOM_GROUP = 'CUSTOM_GROUP',
  SELF_SELECTION = 'SELF_SELECTION',
  AUTO_SELECTION = 'AUTO_SELECTION',
}

export const selectionOptions = [
  {
    value: NewCreatorSelectionModes.JOB_LISTING,
    label: 'Job listings',
    description: 'Select a job you already created and finished negotiations with creators on the Jobs Marketplace',
  },
  {
    value: NewCreatorSelectionModes.CUSTOM_GROUP,
    label: 'Custom group',
    description: 'Select creators from group(s) you already created. (NB: You can only use groups with all creators onboarded.',
  },
  {
    value: NewCreatorSelectionModes.SELF_SELECTION,
    label: 'Self discovery',
    description: 'Discover and pick creators from the hundreds of thousands of profiles on our platform that fit your requirement.',
  },
] as const;
